// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/AlertSection/AlertSection.css
// module id = 381
// module chunks = 0